import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';

import MenuItems from 'components/dropdown/menu_items';
import { Dropdown, MenuItem } from 'react-bootstrap';

import './styles.scss';

export const parentItemIdPrefix = 'dropdown-parent-item';
export const nestedMenuIdPrefix = 'dropdown-menu';

export default function DropdownParentItem({ children, icon, label, nestedMenuClassName, open, ...props }) {
  // react-bootstrap Dropdown components do not forward refs correctly, so set static IDs for lookup
  const parentItemId = useMemo(() => `${parentItemIdPrefix}-${uuid()}`, []);
  const nestedMenuId = useMemo(() => `${nestedMenuIdPrefix}-${uuid()}`, []);

  const [nestedMenuStyle, setNestedMenuStyle] = useState({});

  React.useEffect(() => {
    const style = { ...nestedMenuStyle, visibility: 'hidden' };

    if (open) {
      style.visibility = 'visible';

      const {
        right: parentRight,
        top: parentTop,
        width: parentWidth,
        height: parentHeight,
      } = document.querySelector(`#${parentItemId}`).getBoundingClientRect();

      const {
        width: nestedMenuWidth,
        height: nestedMenuHeight,
      } = document.querySelector(`#${nestedMenuId}`).getBoundingClientRect();

      if (parentRight + nestedMenuWidth < window.innerWidth) {
        style.left = `${parentWidth - 1}px`;
      } else {
        style.left = `-${nestedMenuWidth}px`;
      }

      if (parentTop + nestedMenuHeight < window.innerHeight) {
        style.top = '-8px';
      } else {
        style.top = `-${nestedMenuHeight - parentHeight - 4}px`;
      }
    }

    setNestedMenuStyle(style);
  }, [open]);

  return (
    <MenuItem
      className="dropdown-parent-item"
      id={parentItemId}
      style={{ position: 'relative' }}
      {...props}
    >
      <div>
        {icon && <FontAwesomeIcon icon={icon} />}
        {icon ? ` ${label}` : label}
      </div>
      <FontAwesomeIcon className="ml-2" icon={faCaretRight} />

      <Dropdown.Menu
        className={classNames('dropdown-nested-menu', nestedMenuClassName)}
        id={nestedMenuId}
        style={nestedMenuStyle}
      >
        <MenuItems>
          {children}
        </MenuItems>
      </Dropdown.Menu>
    </MenuItem>
  );
}

DropdownParentItem.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.object,
  label: PropTypes.string.isRequired,
  nestedMenuClassName: PropTypes.string,
  open: PropTypes.bool,
};
